import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, isRef as _isRef, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6d0a1c18"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ml-2" }
const _hoisted_2 = {
  key: 0,
  class: "field col-12 mb-4 -ml-2 -mr-2"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb-2" }, [
  /*#__PURE__*/_createTextVNode("予約日"),
  /*#__PURE__*/_createElementVNode("small", { class: "red-required pl-2" }, "必須")
], -1))
const _hoisted_4 = { class: "field col-12 -mb-1 -ml-2 -mr-2" }
const _hoisted_5 = { class: "flex" }
const _hoisted_6 = {
  key: 2,
  class: "field -mr-2 mb-2"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb-2" }, "繰り返す", -1))
const _hoisted_8 = { class: "formgroup-inline" }
const _hoisted_9 = { class: "field-radiobutton md:mr-1" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "repeat-no",
  class: "ml-2"
}, "いいえ", -1))
const _hoisted_11 = { class: "field-radiobutton md:mr-1" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "repeat-yes",
  class: "ml-2"
}, "はい", -1))
const _hoisted_13 = { key: 0 }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "繰り返す間隔:", -1))
const _hoisted_15 = { key: 0 }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "曜日:", -1))
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { class: "formgroup-inline w-100 mt-2" }
const _hoisted_19 = { class: "field-radiobutton md:mr-1" }
const _hoisted_20 = {
  for: "month-option-day-of-month",
  class: "ml-2 mr-4"
}
const _hoisted_21 = { class: "field-radiobutton md:mr-1" }
const _hoisted_22 = {
  for: "month-option-day-of-week",
  class: "ml-2"
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "終了日:", -1))
const _hoisted_24 = { class: "field-radiobutton md:mr-1 mt-2" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "repeat-end-day",
  class: "ml-2"
}, "終了日:", -1))
const _hoisted_26 = { class: "field-radiobutton md:mr-1" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "repeat-end-times",
  class: "ml-2"
}, "繰り返し:", -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { class: "label-input" }, "回 ", -1))
const _hoisted_29 = {
  key: 3,
  class: "field col-12 mb-4 -ml-2 -mr-2"
}
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "mb-2",
  for: "room"
}, [
  /*#__PURE__*/_createTextVNode("部屋・設備予約"),
  /*#__PURE__*/_createElementVNode("small", { class: "red-required pl-2" }, "必須")
], -1))
const _hoisted_31 = {
  key: 0,
  class: "block p-error text-sm"
}
const _hoisted_32 = { class: "field col-12 mb-4 -ml-2 -mr-2" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "mb-2",
  for: "menu"
}, "カテゴリ", -1))
const _hoisted_34 = { class: "field col-12 mb-4 -ml-2 -mr-2" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "mb-2",
  for: "menu"
}, [
  /*#__PURE__*/_createTextVNode("メニュー"),
  /*#__PURE__*/_createElementVNode("small", { class: "red-required pl-2" }, "必須")
], -1))
const _hoisted_36 = {
  key: 0,
  class: "block p-error text-sm"
}
const _hoisted_37 = { class: "field col-12 mb-4 -ml-2 -mr-2" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "mb-2",
  for: "menuOption"
}, "オプションメニュー", -1))
const _hoisted_39 = { class: "checkbox-list grid grid-nogutter my-2" }
const _hoisted_40 = ["for"]
const _hoisted_41 = { class: "field col-12 mb-4 -ml-2 -mr-2" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "mb-2",
  for: "staff"
}, "担当スタッフ", -1))
const _hoisted_43 = {
  key: 0,
  class: "block p-error text-sm"
}
const _hoisted_44 = { class: "field col-12 mb-4 -ml-2 -mr-2" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "mb-2",
  for: "note_symptom"
}, "気になる部位・お悩みの症状", -1))
const _hoisted_46 = {
  key: 4,
  class: "formgrid formgroup-inline grid w-full flex justify-content-center flex-wrap"
}

import { ref, reactive, withDefaults, onBeforeMount, inject, computed, watch } from "vue";

/**
 * 型定義とenumのインポート
 * 予約関連の型定義とステータス管理用のenumをインポート
 */
import { BookingCustomerStatus, BookingStatusEnum, BookingViewPageTypeEnum } from "@/clinic/typings/enums/booking";

/**
 * VueUse関連のインポート
 * Vue 3のユーティリティライブラリから便利な関数をインポート
 */
import { MaybeRefOrGetter, get, set, useDateFormat } from "@vueuse/core";

/**
 * Vuex関連のインポート
 * 状態管理のためのVuexストアをインポート
 */
import { useStore } from "vuex";

/**
 * ユーティリティライブラリのインポート
 * 配列操作やオブジェクト操作のためのLodashライブラリをインポート
 */
import * as _ from "lodash";

/**
 * 型定義のインポート
 * API通信やデータ構造のための型定義をインポート
 */
import { ApiBaseReqParams, IBooking, IMedicalOption, IMenu, IStaff, IRoom } from "@/clinic/typings";

/**
 * バリデーション関連のインポート
 * フォームバリデーションのためのライブラリをインポート
 */
import { useAsyncValidator } from "@vueuse/integrations/useAsyncValidator";
import { Rule, Rules, ValidateError } from "async-validator";

/**
 * サービス層のインポート
 * API通信を行うためのサービスクラスをインポート
 */
import { CustomerServices, MedicalOptionServices, MenuServices, RoomServices, StaffServices } from "@/clinic/services";

/**
 * ローカルファイルのインポート
 * バリデーションルール、ユーティリティ、子コンポーネントをインポート
 */
import rulesFn from "./rule";
import TimeUtils from "@/clinic/utils/time-utils";
import CustomerField from "./fields/customer/index.vue";
import TimeField from "./fields/booking/time.vue";

/**
 * 定数のインポート
 * アプリケーション全体で使用する定数をインポート
 */
import { PLACEHOLDER_SELECT } from "@/clinic/typings/constants/clinic";

/**
 * PrimeVueコンポーネントのインポート
 * UIコンポーネントライブラリから必要なコンポーネントをインポート
 */
import Calendar from "primevue/calendar";
import RadioButton from "primevue/radiobutton";
import SelectButton from "primevue/selectbutton";
import { DropdownChangeEvent } from "primevue/dropdown";

/**
 * 曜日関連のインポート
 * 曜日選択のためのオプションとenumをインポート
 */
import { dayOfWeekOptions } from "@/clinic/typings/enums/day-of-week";

/**
 * 日付処理ライブラリのインポート
 * 日付操作のためのMoment.jsライブラリをインポート
 */
import moment from "moment";

/**
 * Vue Router関連のインポート
 * ルーティング情報を取得するための機能をインポート
 */
import { useRoute } from "vue-router";

/**
 * 予約フォームの型定義。各プロパティでフォームの状態を管理する。
 * @property {boolean} hasEdit 編集モードかどうかを表す
 * @property {IBooking} model 予約モデル
 * @property {string} bookingDate 予約日
 * @property {string} startTime 開始時間
 * @property {string} endTime 終了時間
 * @property {boolean} changeRepeatParam 繰り返しパラメータ変更フラグ
 * @property {number} roomId 部屋ID
 * @property {number} staffId スタッフID
 * @property {boolean} is_free_space フリースペースフラグ
 */
type IForm = {
  hasEdit?: boolean;
  model: IBooking;
  bookingDate?: string;
  startTime?: string;
  endTime?: string;
  changeRepeatParam: boolean;
  roomId: number;
  staffId: number;
  is_free_space?: boolean;
  note_symptom?: string;
};

/**
 * バリデーション用の型定義。各項目のバリデーション状態を管理する。
 */
type IFormRuleValidation = {
  customerStatus: string;
  startTime: string;
  endTime: string;
  medicalMenuId: number;
  customerId: number;
  is_free_space?: boolean;
};

/**
 * フィールドごとのバリデーションエラーを管理する型。
 */
type IFieldValidator = {
  [key: string]: string;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'form',
  props: {
    hasEdit: { type: Boolean, default: false },
    model: { default: () => ({} as IBooking) },
    bookingDate: null,
    startTime: null,
    endTime: null,
    changeRepeatParam: { type: Boolean, default: false },
    roomId: null,
    staffId: null,
    is_free_space: { type: Boolean },
    note_symptom: { default: "" }
  },
  emits: ["save", "close", "update", "changeRepeatParam"],
  setup(__props: any, { expose, emit: emits }) {

const props = __props as { hasEdit: boolean, model: IBooking, bookingDate?: string, startTime?: string, endTime?: string, changeRepeatParam: boolean, roomId: number, staffId: number, is_free_space?: boolean, note_symptom: string };

/**
 * 予約フォームコンポーネント
 *
 * 予約の作成・編集を行うためのフォームコンポーネント。
 * 顧客、部屋、メニュー、スタッフ、時間などの予約情報を入力・編集できる。
 * 繰り返し予約の設定も可能。
 *
 * @component BookingForm
 */

/**
 * Vue関連のインポート
 * Vue 3のComposition APIを使用するための基本的な機能をインポート
 */
const store = useStore();
const route = useRoute();



const ONLY_CHECK_PASS = "onlyCheckPass";
const repeatRuleOptions = [
  { label: "日ごと", value: 0 },
  { label: "週間ごと", value: 1 },
  { label: "か月ごと", value: 2 },
  { label: "年ごと", value: 3 },
];

/**
 * 予約フォームの状態やデータを管理するリアクティブオブジェクトを初期化する。
 */
const form = reactive({
  id: 0,
  clinicId: 0,
  bookingDate: props.bookingDate,
  startTime: `${props.bookingDate} ${(props.model as any)?.startTimeValue || props.startTime}`,
  startTimeValue: (props.model as any)?.startTimeValue || props.startTime,
  endTimeValue: (props.model as any)?.endTimeValue || props.endTime,
  endTime: `${props.bookingDate} ${(props.model as any)?.endTimeValue || props.endTime}`,
  status: BookingStatusEnum.will_come,
  customerId: 0,
  customerName: props.model?.customer?.name,
  staff: {} as IStaff,
  staffId: props.model.staff_id || props.model.staff?.id,
  roomId: props.model.room_id || props.model.room?.id,
  medicalMenu: {} as IMenu,
  medicalMenuCategoryId: props.model?.medical_menu_category_id || 0,
  medicalMenuId: props.model.medical_menu_id || 0,
  medicalOptions: (props.model as any)?.medical_options || [],
  medicalOptionIds: props.model.medical_option_ids || [],
  note: props.model.note,
  email: "",
  customerFuriName: "",
  customerStatus: BookingCustomerStatus.existed,
  note_symptom: props.note_symptom,
  repeatCode: props.model.repeat_code,
  repeatEnds: props.model.repeat_ends,
  repeatStep: props.model.repeat_step || 1,
  repeatRule: props.model.repeat_rule || 0,
  repeatData: props.model.repeat_data || [],
  repeatStatus: props.model.booking_type == "repeat",
  is_free_space: props.is_free_space,
});

/**
 * クリニックIDを管理するref。
 */
const clinicId = ref(0);
/**
 * フォームDOM要素への参照。
 */
const formModel = ref<HTMLFormElement | null>(null);
/**
 * バリデーション合格状態を管理するref。
 */
const pass = ref(false);
/**
 * バリデーションエラー一覧を管理するref。
 */
const errors = ref<ValidateError[]>([]);
/**
 * 各フィールドごとのバリデーションエラーを管理するref。
 */
const errorFields = ref<Record<string, ValidateError[]>>({});
/**
 * 開始時間フィールドへの参照。
 */
const startTimeField = ref(null);

/**
 * 終了時間フィールドへの参照。
 */
const endTimeField = ref(null);
/**
 * 繰り返し終了タイプを管理するref。
 */
const repeatEndType = ref("day");
/**
 * 繰り返し終了回数を管理するref。
 */
const repeatEndTimes = ref(1);
/**
 * 繰り返し終了日を管理するref。
 */
const repeatEndDay = ref(moment(form.bookingDate).format("YYYY/MM/DD"));
/**
 * 部屋一覧を管理するref。
 */
const rooms = ref<IRoom[]>([]);
/**
 * メニュー一覧を管理するref。
 */
const menus = ref<IMenu[]>([]);
/**
 * オプション一覧を管理するref。
 */
const options = ref<IMedicalOption[]>([]);
/**
 * スタッフ一覧を管理するref。
 */
const staffs = ref<IStaff[]>([]);
/**
 * 予約種別（繰り返し/通常）を計算するcomputed。
 * @returns 予約種別（"repeat" or "normal"）
 */
const formBookingType = computed(() => (form.repeatStatus ? "repeat" : "normal"));
/**
 * 予約時間単位を計算するcomputed。
 * @returns 予約単位（分）
 */
const bookingDuration = computed(() => store.getters["bookingSetting/bookingDuration"]);
/**
 * メニュー・オプションから合計所要時間を計算するcomputed。
 * @returns 合計所要時間（分）
 */
const timeUnit = computed((): number => {
  const { medicalMenu, medicalOptions } = form;
  // メニューの所要時間を取得（分単位）
  const menuTimeUnit = parseInt(medicalMenu?.time_unit) || 0;
  // 選択されたオプションの合計所要時間を計算（分単位）
  const optionTimeUnit = medicalOptions.reduce(
    (acc: number, option: IMedicalOption) => acc + parseInt(option.time_unit),
    0
  );
  // メニューとオプションの合計時間
  const time = menuTimeUnit + optionTimeUnit;
  // 時間が0の場合は予約単位を返す
  if (time == 0) return get(bookingDuration);
  // 予約単位に合わせて切り上げて返す
  const result = Math.ceil(time / get(bookingDuration)) * get(bookingDuration);

  return result;
});
/**
 * 日付から日付文字列を計算するcomputed。
 * @returns 日付文字列
 */
const dayOfMonthOption = computed(() => moment(form.bookingDate).format("D") + "日");
/**
 * ルームカレンダー表示かどうかを判定するcomputed。
 * @returns ルームカレンダー表示ならtrue
 */
const isAtRoomCalendar = computed(() => route.query.view_page == BookingViewPageTypeEnum.RoomCalendar);
/**
 * スタッフカレンダー表示かどうかを判定するcomputed。
 * @returns スタッフカレンダー表示ならtrue
 */
const isAtStaffCalendar = computed(() => route.query.view_page == BookingViewPageTypeEnum.StaffCalendar);

/**
 * カレンダー用の日付を管理するcomputed property
 */
const calendarDate = computed({
  get: () => {
    if (form.bookingDate) {
      const normalizedDate = form.bookingDate.replace(/\//g, "-");
      return new Date(normalizedDate);
    }
    return new Date();
  },
  set: (value: Date) => {
    if (value) {
      const year = value.getFullYear();
      const month = String(value.getMonth() + 1).padStart(2, "0");
      const day = String(value.getDate()).padStart(2, "0");
      form.bookingDate = `${year}/${month}/${day}`;
    }
  },
});

/**
 * カレンダーのデフォルト日付を取得する
 * @returns {Date} デフォルト日付
 */
const getDefaultDate = (): Date => {
  if (form.bookingDate) {
    // 2025/10/07 形式を 2025-10-07 形式に変換
    const normalizedDate = form.bookingDate.replace(/\//g, "-");
    const date = new Date(normalizedDate);
    return date;
  }
  return new Date();
};

/**
 * フィルタ済み顧客一覧を管理するref。
 */
const filteredCustomers = ref([]);
/**
 * 選択中メニューに紐づく部屋のみを返すcomputed。
 * @returns 紐づく部屋一覧
 */
const filteredRooms = computed(() => {
  if (!form.medicalMenuId) return get(rooms);
  const selectedMenu = menus.value.find(menu => menu.id === form.medicalMenuId);
  if (!selectedMenu) return get(rooms);
  if (!selectedMenu.room_ids || selectedMenu.room_ids.length === 0) {
    return get(rooms);
  }
  return get(rooms).filter(room => selectedMenu.room_ids?.includes(room.id));
});
/**
 * 選択中メニューに紐づくカテゴリ、または全メニューに紐づくカテゴリ一覧を返すcomputed。
 *
 * - メニューが選択されている場合：そのメニューに紐づくカテゴリ一覧を返す。
 * - メニュー未選択の場合：全メニューに紐づいているカテゴリ（重複除外）一覧を返す。
 *
 * @returns {Array} カテゴリ一覧
 */
const filteredCategories = computed(() => {
  if (!form.medicalMenuId) {
    // メニューが選択されていない場合：全メニューからカテゴリを収集
    const allCategories = get(menus)
      .flatMap(menu => menu.categories || [])
      .filter(obj => obj && obj.id);
    // 重複を除外してユニークなカテゴリ一覧を作成
    const unique = Object.values(allCategories.reduce((obj, category) => ({ ...obj, [category.id]: category }), {}));
    return unique;
  }
  // メニューが選択されている場合：そのメニューに紐づくカテゴリを返す
  const selectedMenu = menus.value.find(menu => menu.id === form.medicalMenuId);
  return selectedMenu && selectedMenu.categories ? selectedMenu.categories : [];
});
/**
 * 部屋・スタッフ条件でフィルタしたメニュー一覧を返すcomputed。
 * @returns フィルタ済みメニュー一覧
 */
const filteredMenus = computed(() => {
  // 部屋とスタッフが未選択の場合、カテゴリーの条件のみでフィルタリング
  if (!form.roomId && !form.staffId) {
    if (!form.medicalMenuCategoryId) return menus.value;
    return menus.value.filter(
      menu => Array.isArray(menu.categories) && menu.categories.some(cat => cat.id === form.medicalMenuCategoryId)
    );
  }

  // 部屋とスタッフの条件でフィルタリング
  let staffMenuIds: number[] | null = null;
  let isDefaultStaff = false;
  if (form.staffId) {
    const selectedStaff = staffs.value.find(staff => staff.id === form.staffId);
    staffMenuIds = selectedStaff?.medical_menu_ids || [];
    isDefaultStaff = !!selectedStaff?.default_staff;
  }

  // 部屋に関連づいたメニューが一つもなければ、空配列を返す（表示しない）
  if (form.roomId) {
    const hasMenu = menus.value.some(menu => Array.isArray(menu.room_ids) && menu.room_ids.includes(form.roomId));
    if (!hasMenu) return [];
  }

  // 条件すべてでメニューをフィルタリング
  return menus.value.filter(menu => {
    // 部屋の条件（roomId が空なら無条件OK、そうでなければ一致してる必要あり）
    const roomOk = !form.roomId || (Array.isArray(menu.room_ids) && menu.room_ids.includes(form.roomId));
    // スタッフの条件（staffId が空 or デフォルトスタッフ or 対応メニューに含まれている）
    const staffOk =
      !form.staffId || isDefaultStaff || (Array.isArray(staffMenuIds) && menu.id && staffMenuIds.includes(menu.id));
    // カテゴリーの条件（未選択ならOK、選択されてる場合は一致する必要あり）
    const categoryOk =
      !form.medicalMenuCategoryId ||
      (Array.isArray(menu.categories) && menu.categories.some(cat => cat.id === form.medicalMenuCategoryId));

    return roomOk && staffOk && categoryOk;
  });
});
/**
 * 選択中メニューに紐づくオプションのみを返すcomputed。
 * @returns 紐づくオプション一覧
 */
const filteredOptions = computed(() => {
  return get(options).filter(option => (option as any).medical_menu_ids?.includes(form.medicalMenuId));
});
/**
 * 選択中メニューに紐づくスタッフのみを返すcomputed。
 * @returns 紐づくスタッフ一覧
 */
const filteredStaffs = computed(() => {
  if (get(isAtStaffCalendar)) return get(staffs);
  return get(staffs).filter(staff => {
    if (form.medicalMenuId) return staff.medical_menu_ids?.includes(form.medicalMenuId);
    else return staff.medical_menu_ids?.length > 0;
  });
});

/**
 * 予約保存処理を実行する。
 * @returns void
 */
const onSave = () => emits("save");
/**
 * フォームを閉じる処理を実行する。
 * @returns void
 */
const onClose = () => emits("close");
/**
 * 予約種別の更新処理を実行する。
 * @returns void
 */
const onUpdate = () => emits("update", form.repeatStatus ? "repeat" : "normal");

/**
 * クリニックIDを取得する非同期関数。
 * @returns {Promise<ApiBaseReqParams>} クリニックIDを含むリクエストパラメータ
 */
const clinicIdParams = async (): Promise<ApiBaseReqParams> => ({ clinic_id: get(await get(clinicId)) });
/**
 * バリデーション初期化関数。
 * @param value バリデーション対象の値
 * @param rules バリデーションルール
 * @returns バリデーションインスタンス
 */
const initValidation = (value: IFieldValidator | any, rules: MaybeRefOrGetter<Record<string, Rule | Rules>>) =>
  useAsyncValidator(value, rules, { validateOption: { suppressWarning: true } });
/**
 * バリデーションを実行する。
 * @param fieldName チェックするフィールド名（省略可）
 * @returns バリデーションが通ればtrue
 */
const validate = async (fieldName?: string): Promise<boolean> => {
  const { customerStatus, startTime, endTime, medicalMenuId, customerId, is_free_space } = form;
  const fieldTime = {
    startTime,
    endTime,
    customerStatus,
    medicalMenuId,
    customerId,
    is_free_space,
  } as IFormRuleValidation;
  const formRules = rulesFn(fieldTime);
  const [value, rules] = fieldName
    ? [{ [fieldName]: (form as any)[fieldName] }, { [fieldName]: (formRules as any)[fieldName] }]
    : [form, formRules];

  const { pass: formPass } = initValidation(form, formRules);
  const { execute } = initValidation(value, rules);
  const { errorFields: fErrorFields, errors: fErrors } = await execute();
  set(pass, get(formPass));

  if (fieldName !== ONLY_CHECK_PASS) {
    set(errorFields, get(fErrorFields));
  }

  set(errors, get(fErrors));
  return get(pass) as boolean;
};
/**
 * モデルデータをロードする。
 * @returns Promise<void>
 */
const loadModel = async (): Promise<void> => {
  form.clinicId = get(await get(clinicId));
  // 編集モードでない場合は早期リターン
  if (!props.hasEdit) {
    form.is_free_space = props.model.is_free_space ?? false;
    return;
  }

  // モデルにIDがない場合（複製時など）は、基本的な設定のみ行う
  if (!props.model.id) {
    form.is_free_space = props.model.is_free_space ?? false;

    // 複製時は顧客情報を設定
    if (props.model.customer_id) {
      form.customerId = props.model.customer_id;
    }
    if (props.model.customer_name) {
      form.customerName = props.model.customer_name;
    }
    if (props.model.customer) {
      (form as any).customer = props.model.customer;
    }

    // 複製時は予約日と時間を設定（元の予約日時を初期値として使用）
    if (props.model.start_time) {
      const bookingDate = TimeUtils.formatDateYMD(TimeUtils.toLocalTime(props.model.start_time.toString()));
      form.bookingDate = bookingDate;

      // 開始時間と終了時間を正しい形式で設定
      const startTime = TimeUtils.toLocalTime(props.model.start_time.toString());
      const endTime = TimeUtils.toLocalTime(props.model.end_time.toString());

      form.startTime = `${bookingDate} ${get(useDateFormat(startTime, "HH:mm"))}`;
      form.endTime = `${bookingDate} ${get(useDateFormat(endTime, "HH:mm"))}`;
      form.startTimeValue = get(useDateFormat(startTime, "HH:mm"));
      form.endTimeValue = get(useDateFormat(endTime, "HH:mm"));
    }

    // 複製時はメニュー情報を設定
    if (props.model.medical_menu) {
      form.medicalMenu = props.model.medical_menu;
      form.medicalMenuId = props.model.medical_menu_id ?? 0;
      form.medicalMenuCategoryId = props.model.medical_menu_category_id ?? 0;
    }

    // 複製時はオプション情報を設定（元の予約で実際に選択されていたオプションのみ）
    if (props.model.medical_option_ids && props.model.medical_option_ids.length > 0) {
      form.medicalOptionIds = [...props.model.medical_option_ids];
    } else {
      form.medicalOptionIds = [];
    }

    // 複製時はオプションを取得する
    if (props.model.medical_menu?.medical_option_ids) {
      await fetchOptions(props.model.medical_menu.medical_option_ids);
    }
    return;
  }

  // 予約日時をローカル時間に変換してフォーマット
  const bookingDate = TimeUtils.formatDateYMD(TimeUtils.toLocalTime(props.model.start_time.toString()));
  let startTime = TimeUtils.toHourEmptyMinute(props.model.start_time.toString());
  let endTime = TimeUtils.toHourEmptyMinute(props.model.end_time.toString());
  if (props.hasEdit) {
    // 編集モードの場合は時間をHH:mm形式で表示
    startTime = get(useDateFormat(TimeUtils.toLocalTime(props.model.start_time.toString()), "HH:mm"));
    endTime = get(useDateFormat(TimeUtils.toLocalTime(props.model.end_time.toString()), "HH:mm"));
  }

  // 繰り返しデータの形式をルールに応じて変換
  let repeatDataFormat = props.model.repeat_data;
  if (props.model.repeat_rule == 1) {
    // 週間ごとの場合：数値配列に変換
    repeatDataFormat = props.model.repeat_data.map(Number);
  } else if (props.model.repeat_rule == 2) {
    // 月ごとの場合：最初の要素を取得
    repeatDataFormat = props.model.repeat_data[0];
  }

  // 自由予約でmedical_menu_category_idがnullの場合も、通常予約と同じロジックを適用
  // フリースペース予約では、medical_menu_category_idが明示的に保存されないため
  // 既存の値がある場合はそれを使用し、ない場合は0（未選択）のままにする
  const medicalMenuCategoryId = props.model.medical_menu_category_id || 0;

  const updateProps = {
    id: props.model.id,
    customerId: props.model.customer_id,
    customerStatus: props.model.customer_id ? BookingCustomerStatus.existed : BookingCustomerStatus.new,
    customerName: props.model.customer.name || props.model.customer_name,
    staff: props.model.staff,
    staffId: props.model.staff_id || props.model.staff.id,
    staffName: props.model.staff_name,
    bookingDate,
    startTime: `${bookingDate} ${startTime}`,
    endTime: `${bookingDate} ${endTime}`,
    startTimeValue: startTime,
    endTimeValue: endTime,
    room: props.model.room,
    roomId: props.model.room_id || props.model.room.id,
    medicalMenu: props.model.medical_menu,
    medicalMenuId: props.model.medical_menu_id,
    medicalMenuCategoryId: medicalMenuCategoryId,
    medicalOptionIds: props.model.medical_option_ids,
    repeatCode: props.model.repeat_code,
    repeatEnds: props.model.repeat_ends,
    repeatData: repeatDataFormat,
    repeatRule: props.model.repeat_rule,
    repeatStep: props.model.repeat_step,
    is_free_space: props.model.is_free_space,
  };
  Object.assign(form, updateProps);
  const repeatEndData = JSON.parse(props.model.repeat_ends);
  if (repeatEndData != null) {
    if (Object.keys(repeatEndData).includes("on")) {
      set(repeatEndType, "day");
      set(repeatEndDay, TimeUtils.formatDateYMD(repeatEndData["on"]));
    } else {
      set(repeatEndType, "times");
      set(repeatEndTimes, repeatEndData["after"]);
    }
  }
  // 編集時・複製時ともにオプションを取得
  if (props.hasEdit || (!props.hasEdit && form.medicalMenu?.medical_option_ids)) {
    await fetchOptions(form.medicalMenu.medical_option_ids);
  }

  // オプションが設定されている場合の処理（編集時・複製時共通）
  if (form.medicalOptionIds && form.medicalOptionIds.length > 0) {
    // オプションが取得できている場合のみ設定
    if (get(options).length > 0) {
      set(
        form,
        "medicalOptions",
        get(options).filter(option => option.id && form.medicalOptionIds.includes(option.id))
      );

      // チェックボックスの状態を確実に反映するため、medicalOptionIdsを再設定
      set(form, "medicalOptionIds", [...form.medicalOptionIds]);
    }
  }
};
/**
 * フォームDOM要素を取得する。
 * @returns HTMLFormElement
 */
const getForm = (): HTMLFormElement => get(formModel) as HTMLFormElement;
/**
 * 日付から曜日の序数を取得する。
 * @returns 曜日の序数
 */
const getNumericalOrderOfWeekDay = () => {
  // 指定日の曜日と月初の曜日の差分を計算
  const weekDayDiff = moment(form.bookingDate).isoWeekday() - moment(form.bookingDate).startOf("month").isoWeekday();
  // 月初から同じ曜日で最も近い日を計算
  const nearestSameWdayFromBegin = moment(form.bookingDate)
    .startOf("month")
    .add(weekDayDiff < 0 ? 7 + weekDayDiff : weekDayDiff, "days");
  // 指定日が何番目の同じ曜日かを計算
  const numericalOrder = (moment(form.bookingDate).date() - moment(nearestSameWdayFromBegin).date()) / 7 + 1;
  // 5番目以降は「最終」、それ以外は「第N」を返す
  return numericalOrder > 4 ? "最終" : "第 " + numericalOrder;
};
/**
 * 繰り返しデータをリセットする。
 * @param ruleId ルールID
 * @returns Promise<void>
 */
const resetRepeatData = async (ruleId: any): Promise<void> => {
  if (ruleId == 1) {
    set(form, "repeatData", [new Date(form.startTime).getDay()]);
  } else if (ruleId == 2) {
    set(form, "repeatData", "day_of_month");
  } else {
    set(form, "repeatData", []);
  }
};
/**
 * 部屋選択をリセットする。
 * @returns void
 */
const resetRoom = () => {
  if (get(isAtRoomCalendar)) return;

  if (!get(filteredRooms).some(room => room.id == form.roomId)) set(form, "roomId", 0);
};
/**
 * カテゴリ選択をリセットする。
 * @returns void
 */
const resetMenuCategory = () => {
  if (!get(filteredCategories).some((cate: any) => cate.id == form.medicalMenuCategoryId))
    set(form, "medicalMenuCategoryId", 0);
  resetMenu();
};
/**
 * メニュー選択をリセットする。
 * @returns void
 */
const resetMenu = () => {
  if (!get(filteredMenus).some(menu => menu.id == form.medicalMenuId)) {
    set(form, "medicalMenuId", 0);
    set(form, "medicalMenu", {} as IMenu);
  }
};
/**
 * スタッフ選択をリセットする。
 * @returns void
 */
const resetStaff = () => {
  if (get(isAtStaffCalendar)) return;

  if (!get(filteredStaffs).some(staff => staff.id == form.staffId)) {
    set(form, "staffId", 0);
  }
};

/**
 * 顧客選択時の処理を実行する。
 * @param customerId 選択されたカルテNo.
 * @returns void
 */
const onChangingCustomer = (customerId: number) => {
  set(form, "customerId", customerId);
  validate("customerId");
};
/**
 * 顧客ステータス変更時の処理を実行する。
 * @param newStatus 新しい顧客ステータス
 * @returns void
 */
const onChangingCustomerStatus = (newStatus: string) => {
  set(form, "customerStatus", newStatus as BookingCustomerStatus);
  validate(ONLY_CHECK_PASS);
};
/**
 * 顧客名変更時の処理を実行する。
 * @param newName 新しい顧客名
 * @returns void
 */
const onChangingCustomerName = (newName: string) => {
  set(form, "customerName", newName);
  validate("customerName");
};
/**
 * 部屋変更時の処理を実行する。
 * @returns true
 */
const onChangingRoom = () => {
  resetMenuCategory();
  if (get(isAtRoomCalendar)) resetStaff();
  return true;
};
/**
 * オプション変更時の処理を実行する。
 * @returns Promise<boolean>
 */
const onChangingMedicalOption = async (): Promise<boolean> => {
  set(
    form,
    "medicalOptions",
    get(filteredOptions).filter(option => option.id && form.medicalOptionIds.includes(option.id))
  );
  setEndTimeWithTimeUnit();
  return true;
};

/**
 * メニュー変更時の処理を実行する。
 * @param selectedMenuId 選択されたメニューID
 * @returns Promise<boolean>
 */
const onChangingMedicalMenu = async (selectedMenuId: number): Promise<boolean> => {
  const selectedMenu = get(filteredMenus)?.find(menu => menu.id == selectedMenuId);
  set(form, "medicalMenu", selectedMenu || ({} as IMenu));
  await fetchOptions(form.medicalMenu.medical_option_ids);
  set(form, "medicalOptionIds", []);
  set(form, "medicalOptions", []);
  setEndTimeWithTimeUnit();
  if (!get(isAtStaffCalendar)) fetchStaffs();
  return true;
};
/**
 * スタッフ変更時の処理を実行する。
 * @param staffId 選択されたスタッフID
 * @returns Promise<boolean>
 */
const onChangingStaff = async (staffId: number): Promise<boolean> => {
  set(form, "staff", get(filteredStaffs).find(staff => staff.id == staffId) || ({} as IStaff));
  setEndTimeWithTimeUnit();
  resetMenuCategory();
  resetRoom();
  return true;
};
/**
 * 開始時間変更時の処理を実行する。
 * @param startTime 新しい開始時間
 * @returns void
 */
const onChangingStartTime = (startTime: string) => {
  set(form, "startTime", startTime);
  setEndTimeWithTimeUnit();
  if (!get(isAtStaffCalendar)) fetchStaffs();
  validate("startTime");
};
/**
 * 終了時間変更時の処理を実行する。
 * @param endTime 新しい終了時間
 * @returns void
 */
const onChangingEndTime = (endTime: string) => {
  set(form, "endTime", endTime);
  if (!get(isAtStaffCalendar)) fetchStaffs();
  validate("endTime");
};
/**
 * 繰り返しパラメータ変更時の処理を実行する。
 * @returns void
 */
const onChangeRepeatParam = () => emits("changeRepeatParam");
/**
 * 所要時間から終了時間を計算してセットする。
 * @returns void
 */
const setEndTimeWithTimeUnit = () => {
  // 開始時間が設定されていない場合は処理をスキップ
  if (!form.startTime) {
    return;
  }

  // 開始時間に所要時間（分）を加算して終了時間を計算
  const startDate = new Date(form.startTime);
  if (isNaN(startDate.getTime())) {
    return;
  }

  const endTime = new Date(startDate.getTime() + get(timeUnit) * 60 * 1000);

  // フォームの終了時間を更新
  const endTimeStr = endTime.toISOString();
  const endTimeValue = get(useDateFormat(endTime, "HH:mm"));
  set(form, "endTime", endTimeStr);
  set(form, "endTimeValue", endTimeValue);

  // 終了時間フィールドの表示も更新
  const endTimeFieldRef = get(endTimeField);
  if (endTimeFieldRef && typeof (endTimeFieldRef as any).setFormTime === "function") {
    (endTimeFieldRef as any).setFormTime(get(useDateFormat(endTime, "HH")), get(useDateFormat(endTime, "mm")));
  }
};

/**
 * メニュー一覧をAPIから取得する。
 * @returns Promise<void>
 */
const fetchMenus = async (): Promise<void> => {
  const result = await MenuServices.getBookingMedicalMenus(await clinicIdParams());
  const selectedRoomId = form.roomId;
  set(
    menus,
    ((result.data.value as any)?.menus || []).filter((menu: any) => {
      if (!selectedRoomId) return true;
      return menu.room_ids && menu.room_ids.includes(selectedRoomId);
    })
  );
};
/**
 * 部屋一覧をAPIから取得する。
 * @returns Promise<void>
 */
const fetchRooms = async (): Promise<void> => {
  const { data } = await RoomServices.fetchRooms(
    await clinicIdParams(),
    () => undefined,
    () => undefined,
    () => undefined
  );
  set(rooms, get(data).rooms);
};
/**
 * スタッフ一覧をAPIから取得する。
 * @returns Promise<void>
 */
const fetchStaffs = async (): Promise<void> => {
  const { data } = await StaffServices.getStaffs({
    default_staff: "yes",
    ...(await clinicIdParams()),
  });
  const result = (get(data) as any)?.staffs;
  if (props.hasEdit && !result.some((staff: any) => staff.id == form.staffId)) result.push(props.model.staff);
  set(staffs, result);
};
/**
 * オプション一覧をAPIから取得する。
 * @param ids オプションID配列
 * @returns Promise<void>
 */
const fetchOptions = async (ids: number[] | undefined): Promise<void> => {
  if (!ids) return;

  if (ids.length == 0) {
    set(options, []);
    return;
  }
  const { data } = await MedicalOptionServices.getOptions(
    { ids, ...(await clinicIdParams()) },
    () => undefined,
    err => err
  );
  set(options, (get(data) as any)?.options);
};
/**
 * 顧客一覧をAPIから取得する。
 * @returns Promise<void>
 */
const fetchCustomers = async (): Promise<void> => {
  if (props.hasEdit) set(filteredCustomers, [{ id: form.customerId, name: form.customerName }]);

  const { data } = await CustomerServices.getBookingCustomers(
    await clinicIdParams(),
    () => undefined,
    (error: Error) => error
  );
  set(filteredCustomers, (get(data) as any)?.customers);
};
/**
 * 予約画面で必要な全データを取得する。
 * @returns Promise<void>
 */
const fetchData = async (): Promise<void> => {
  await fetchMenus();
  await fetchRooms();
  await fetchStaffs();
  await fetchCustomers();
};

/**
 * オプションIDの変更を監視して時間を自動調整
 */
watch(
  () => form.medicalOptionIds,
  (newOptionIds, oldOptionIds) => {
    // オプションが変更された場合、時間を再計算
    if (newOptionIds !== oldOptionIds) {
      // オプション情報を更新
      set(
        form,
        "medicalOptions",
        get(filteredOptions).filter(option => option.id && newOptionIds.includes(option.id))
      );

      // 終了時間を再計算
      setEndTimeWithTimeUnit();
    }
  },
  { deep: true }
);

/**
 * マウント前に初期データを取得する。
 * @returns void
 */
onBeforeMount(async () => {
  set(clinicId, await inject("clinicId"));
  loadModel();
  await fetchData();

  if (props.staffId) {
    form.staff = get(staffs).find(staff => staff.id == props.staffId) as unknown as IStaff;
  }
  if (props.roomId) {
    (form as any).room = get(rooms).find(room => room.id == props.roomId) as unknown as IRoom;
  }

  // 複製時にオプションが設定されている場合は、オプションを再設定
  if (form.medicalOptionIds && form.medicalOptionIds.length > 0) {
    // オプションが取得されていない場合は、強制的に取得
    if (get(options).length === 0 && form.medicalMenu?.medical_option_ids) {
      await fetchOptions(form.medicalMenu.medical_option_ids);
    }

    if (get(options).length > 0) {
      const filteredOptions = get(options).filter(option => option.id && form.medicalOptionIds.includes(option.id));
      set(form, "medicalOptions", filteredOptions);

      // チェックボックスの状態を確実に反映するため、medicalOptionIdsを再設定
      set(form, "medicalOptionIds", [...form.medicalOptionIds]);
    }
  } else {
    // 複製時でオプションIDが設定されていない場合、オプションは選択なしとする
    form.medicalOptionIds = [];
    set(form, "medicalOptions", []);
  }
});

/**
 * コンポーネントの外部に公開するメソッドを定義する
 * @expose {Function} getForm - フォームDOM要素を取得するメソッド
 * @expose {Function} validate - バリデーションを実行するメソッド
 */
/**
 * 選択されたオプション情報を取得する
 * @returns {Array} 選択されたオプションの配列
 */
const getMedicalOptions = () => {
  return form.medicalOptions || [];
};

// eslint-disable-next-line no-undef
expose({
  getForm,
  validate,
  getMedicalOptions,
  form, // フォームオブジェクト自体を公開
});

/**
 * フォームの全フィルターをリセットする。
 * 繰り返し設定、部屋、スタッフ、カテゴリ、メニューの選択をクリアする。
 * 予約内容の更新時は顧客情報はクリアしない。
 * @returns void
 */
const resetAllFilters = () => {
  set(form, "repeatRule", 0);
  set(form, "repeatStep", 1);
  set(form, "endTime", "");
  set(repeatEndType, "day");
  set(repeatEndDay, form.bookingDate ? form.bookingDate : "");
  set(repeatEndTimes, 1);

  // 予約内容の更新時は顧客情報をクリアしない
  if (!props.hasEdit) {
    set(form, "customerId", 0);
  }

  set(form, "roomId", 0);
  set(form, "staffId", 0);
  set(form, "medicalMenuCategoryId", 0);
  set(form, "medicalMenuId", 0);
};

return (_ctx: any,_cache: any) => {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_Textarea = _resolveComponent("Textarea")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("form", {
      ref_key: "formModel",
      ref: formModel,
      class: "formgrid grid min-w-328"
    }, [
      _createVNode(_component_InputText, {
        value: form.clinicId,
        name: "clinic_id",
        class: "hidden"
      }, null, 8, ["value"]),
      (form.id || __props.hasEdit)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _hoisted_3,
            _createVNode(_unref(Calendar), {
              modelValue: _unref(calendarDate),
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(calendarDate) ? (calendarDate).value = $event : null)),
              dateFormat: "yy/mm/dd",
              manualInput: false,
              showIcon: "",
              showButtonBar: "",
              defaultDate: getDefaultDate()
            }, null, 8, ["modelValue", "defaultDate"])
          ]))
        : (_openBlock(), _createBlock(_component_InputText, {
            key: 1,
            modelValue: form.bookingDate,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.bookingDate) = $event)),
            class: "hidden"
          }, null, 8, ["modelValue"])),
      _createVNode(_component_InputText, {
        value: form.note,
        name: "note",
        class: "hidden"
      }, null, 8, ["value"]),
      _createVNode(_component_InputText, {
        value: form.is_free_space,
        name: "is_free_space",
        class: "hidden"
      }, null, 8, ["value"]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(TimeField, {
            ref_key: "startTimeField",
            ref: startTimeField,
            name: "start_time",
            date: form.bookingDate,
            value: form.startTimeValue,
            fieldLabel: "予約時間",
            errorFields: errorFields.value,
            duration: _unref(bookingDuration),
            onChangingHour: onChangingStartTime,
            onChangingMinute: onChangingStartTime
          }, null, 8, ["date", "value", "errorFields", "duration"]),
          _createVNode(_component_Button, {
            class: "p-button-outlined p-button-sm -ml-8 sticky-clear-btn",
            style: {"min-width":"120px","white-space":"nowrap","background":"#fff","border-color":"#bbb","color":"#666"},
            onClick: resetAllFilters,
            label: "入力をクリア",
            "aria-label": "入力をクリア"
          })
        ])
      ]),
      (!form.is_free_space)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_InputText, {
                value: _unref(formBookingType),
                class: "hidden",
                name: "booking_type"
              }, null, 8, ["value"]),
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_unref(RadioButton), {
                  inputId: "repeat-no",
                  name: "repeat-status",
                  modelValue: form.repeatStatus,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.repeatStatus) = $event)),
                  value: false,
                  required: true,
                  onChange: onUpdate
                }, null, 8, ["modelValue"]),
                _hoisted_10
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_unref(RadioButton), {
                  inputId: "repeat-yes",
                  name: "repeat-status",
                  modelValue: form.repeatStatus,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.repeatStatus) = $event)),
                  value: true,
                  required: true,
                  onChange: onUpdate
                }, null, 8, ["modelValue"]),
                _hoisted_12
              ])
            ]),
            (form.repeatStatus)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  _hoisted_14,
                  _createVNode(_component_InputText, {
                    type: "number",
                    min: 1,
                    name: "repeat_step",
                    class: "w-2 mr-3 ml-2",
                    modelValue: form.repeatStep,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.repeatStep) = $event)),
                    onChange: onChangeRepeatParam
                  }, null, 8, ["modelValue"]),
                  _createVNode(_component_InputText, {
                    value: form.repeatRule,
                    class: "hidden",
                    name: "repeat_rule",
                    onChange: onChangeRepeatParam
                  }, null, 8, ["value"]),
                  _createVNode(_component_Dropdown, {
                    modelValue: form.repeatRule,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((form.repeatRule) = $event)),
                    options: repeatRuleOptions,
                    optionValue: "value",
                    optionLabel: "label",
                    class: "mr-2 w-7rem font-normal mb-2",
                    inputProps: { class: 'font-light text-black20 text-sm' },
                    placeholder: _unref(PLACEHOLDER_SELECT),
                    onChange: _cache[6] || (_cache[6] = async ({ value: ruleId }: DropdownChangeEvent) => await resetRepeatData(ruleId))
                  }, null, 8, ["modelValue", "placeholder"]),
                  (form.repeatRule == 1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                        _hoisted_16,
                        _createVNode(_component_InputText, {
                          value: form.repeatData,
                          class: "hidden",
                          name: "repeat_data"
                        }, null, 8, ["value"]),
                        _createVNode(_unref(SelectButton), {
                          modelValue: form.repeatData,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((form.repeatData) = $event)),
                          options: _unref(dayOfWeekOptions),
                          optionLabel: "label",
                          optionValue: "value",
                          multiple: "",
                          "aria-labelledby": "multiple",
                          class: "mb-4 mt-2",
                          onChange: onChangeRepeatParam
                        }, null, 8, ["modelValue", "options"])
                      ]))
                    : _createCommentVNode("", true),
                  (form.repeatRule == 2)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                        _createElementVNode("div", _hoisted_18, [
                          _createElementVNode("div", _hoisted_19, [
                            _createVNode(_unref(RadioButton), {
                              inputId: "month-option-day-of-month",
                              name: "repeat_data[]",
                              modelValue: form.repeatData,
                              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((form.repeatData) = $event)),
                              value: "day_of_month",
                              required: true,
                              onChange: onChangeRepeatParam
                            }, null, 8, ["modelValue"]),
                            _createElementVNode("label", _hoisted_20, "毎月 " + _toDisplayString(_unref(dayOfMonthOption)), 1)
                          ]),
                          _createElementVNode("div", _hoisted_21, [
                            _createVNode(_unref(RadioButton), {
                              inputId: "month-option-day-of-week",
                              name: "repeat_data[]",
                              modelValue: form.repeatData,
                              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((form.repeatData) = $event)),
                              value: "day_of_week",
                              required: true,
                              onChange: onChangeRepeatParam
                            }, null, 8, ["modelValue"]),
                            _createElementVNode("label", _hoisted_22, "毎月 " + _toDisplayString(getNumericalOrderOfWeekDay()) + " " + _toDisplayString(_unref(dayOfWeekOptions)[_unref(moment)(form.bookingDate).days()].label) + "曜日", 1)
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _hoisted_23,
                  _createElementVNode("div", _hoisted_24, [
                    _createVNode(_unref(RadioButton), {
                      inputId: "repeat-end-day",
                      name: "repeat-end-type",
                      modelValue: repeatEndType.value,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((repeatEndType).value = $event)),
                      value: "day",
                      onChange: onChangeRepeatParam
                    }, null, 8, ["modelValue"]),
                    _hoisted_25,
                    _createVNode(_component_InputText, {
                      value: repeatEndDay.value,
                      class: "hidden",
                      name: "repeat_ends",
                      disabled: repeatEndType.value == 'times'
                    }, null, 8, ["value", "disabled"]),
                    _createVNode(_unref(Calendar), {
                      modelValue: repeatEndDay.value,
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((repeatEndDay).value = $event)),
                      class: "justify-content-center h-100 w-6 ml-4",
                      showButtonBar: "",
                      showIcon: "",
                      dateFormat: "yy/mm/dd",
                      onChange: onChangeRepeatParam,
                      disabled: repeatEndType.value == 'times'
                    }, null, 8, ["modelValue", "disabled"])
                  ]),
                  _createElementVNode("div", _hoisted_26, [
                    _createVNode(_unref(RadioButton), {
                      inputId: "repeat-end-times",
                      name: "repeat-end-type",
                      modelValue: repeatEndType.value,
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((repeatEndType).value = $event)),
                      value: "times",
                      onChange: onChangeRepeatParam
                    }, null, 8, ["modelValue"]),
                    _hoisted_27,
                    _createVNode(_component_InputText, {
                      type: "number",
                      min: 1,
                      name: "repeat_ends",
                      class: "w-2 mr-3 repeat-end-times",
                      value: repeatEndTimes.value,
                      disabled: repeatEndType.value == 'day',
                      onChange: onChangeRepeatParam,
                      modelValue: repeatEndTimes.value,
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((repeatEndTimes).value = $event))
                    }, null, 8, ["value", "disabled", "modelValue"]),
                    _hoisted_28
                  ])
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      _createVNode(CustomerField, {
        id: form.customerId,
        customers: filteredCustomers.value,
        errorFields: errorFields.value,
        customerStatus: form.customerStatus,
        hasEdit: __props.hasEdit,
        onChangingCustomer: onChangingCustomer,
        onChangingCustomerStatus: onChangingCustomerStatus,
        onChangingName: onChangingCustomerName
      }, null, 8, ["id", "customers", "errorFields", "customerStatus", "hasEdit"]),
      (!form.is_free_space)
        ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
            _hoisted_30,
            _createVNode(_component_InputText, {
              value: (form as any).room?.name,
              class: "hidden",
              name: "room_name"
            }, null, 8, ["value"]),
            _createVNode(_component_InputText, {
              value: form.roomId,
              class: "hidden",
              name: "room_id"
            }, null, 8, ["value"]),
            _createVNode(_component_Dropdown, {
              modelValue: form.roomId,
              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((form.roomId) = $event)),
              options: _unref(filteredRooms),
              optionValue: "id",
              optionLabel: "name",
              class: "mr-2 max-w-6rem font-normal min-w-250",
              inputProps: { class: 'font-light text-black20 text-sm', name: 'room_id' },
              placeholder: _unref(PLACEHOLDER_SELECT),
              onChange: _cache[15] || (_cache[15] = async () => onChangingRoom() && (await validate('roomId')))
            }, null, 8, ["modelValue", "options", "placeholder"]),
            (errorFields.value?.roomId)
              ? (_openBlock(), _createElementBlock("small", _hoisted_31, _toDisplayString(_.head(errorFields.value.roomId)?.message), 1))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_32, [
        _hoisted_33,
        _createVNode(_component_InputText, {
          value: form.medicalMenuCategoryId,
          class: "hidden",
          name: "medical_menu_category_id"
        }, null, 8, ["value"]),
        _createVNode(_component_Dropdown, {
          modelValue: form.medicalMenuCategoryId,
          "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((form.medicalMenuCategoryId) = $event)),
          options: _unref(filteredCategories),
          optionValue: "id",
          optionLabel: "name",
          class: "mr-2 max-w-6rem font-normal min-w-250",
          inputProps: { class: 'font-light text-black20 text-sm' },
          placeholder: _unref(PLACEHOLDER_SELECT)
        }, null, 8, ["modelValue", "options", "placeholder"])
      ]),
      _createElementVNode("div", _hoisted_34, [
        _hoisted_35,
        _createVNode(_component_InputText, {
          value: form.medicalMenu?.name,
          class: "hidden",
          name: "medical_menu_name"
        }, null, 8, ["value"]),
        _createVNode(_component_InputText, {
          value: form.medicalMenuId,
          class: "hidden",
          name: "medical_menu_id",
          onInput: _cache[17] || (_cache[17] = ($event: any) => (validate('medicalMenuId')))
        }, null, 8, ["value"]),
        _createVNode(_component_Dropdown, {
          modelValue: form.medicalMenuId,
          "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((form.medicalMenuId) = $event)),
          options: _unref(filteredMenus),
          optionValue: "id",
          optionLabel: "name",
          class: "mr-2 max-w-6rem font-normal min-w-250",
          inputProps: { class: 'font-light text-black20 text-sm', name: 'medical_menu_id' },
          onChange: _cache[19] || (_cache[19] = 
            async ({ value: medicalMenuId }: DropdownChangeEvent) =>
              (await onChangingMedicalMenu(medicalMenuId)) && (await validate('medicalMenuId'))
          ),
          placeholder: _unref(PLACEHOLDER_SELECT)
        }, null, 8, ["modelValue", "options", "placeholder"]),
        (errorFields.value?.medicalMenuId)
          ? (_openBlock(), _createElementBlock("small", _hoisted_36, _toDisplayString(_.head(errorFields.value.medicalMenuId)?.message), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_37, [
        _hoisted_38,
        _createElementVNode("div", _hoisted_39, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(filteredOptions), ({ id: optionId, name: optionName }) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "field-checkbox col-12",
              key: optionId
            }, [
              _createVNode(_component_Checkbox, {
                modelValue: form.medicalOptionIds,
                "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((form.medicalOptionIds) = $event)),
                inputId: `checkbox-options-${optionId}`,
                name: "medical_option_ids[]",
                value: optionId,
                class: "checkbox",
                onChange: onChangingMedicalOption
              }, null, 8, ["modelValue", "inputId", "value"]),
              _createElementVNode("label", {
                for: `checkbox-options-${optionId}`,
                class: "text-700 ml-1"
              }, _toDisplayString(optionName), 9, _hoisted_40)
            ]))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_41, [
        _hoisted_42,
        _createVNode(_component_InputText, {
          class: "hidden",
          name: "staff_id",
          value: form.staffId
        }, null, 8, ["value"]),
        _createVNode(_component_Dropdown, {
          modelValue: form.staffId,
          "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((form.staffId) = $event)),
          options: _unref(filteredStaffs),
          optionValue: "id",
          optionLabel: "title",
          class: "mr-2 max-w-6rem font-normal min-w-250",
          inputProps: { class: 'font-light text-black20 text-sm' },
          placeholder: _unref(PLACEHOLDER_SELECT),
          onChange: _cache[22] || (_cache[22] = 
            async ({ value: staffId }: DropdownChangeEvent) =>
              (await onChangingStaff(staffId)) && (await validate('staffId'))
          )
        }, null, 8, ["modelValue", "options", "placeholder"]),
        (errorFields.value?.staffId)
          ? (_openBlock(), _createElementBlock("small", _hoisted_43, _toDisplayString(_.head(errorFields.value.staffId)?.message), 1))
          : _createCommentVNode("", true)
      ]),
      _createVNode(TimeField, {
        ref_key: "endTimeField",
        ref: endTimeField,
        name: "end_time",
        date: form.bookingDate,
        value: form.endTimeValue,
        fieldLabel: "施術終了時間",
        errorFields: errorFields.value,
        duration: _unref(bookingDuration),
        onChangingHour: onChangingEndTime,
        onChangingMinute: onChangingEndTime
      }, null, 8, ["date", "value", "errorFields", "duration"]),
      _createElementVNode("div", _hoisted_44, [
        _hoisted_45,
        _createVNode(_component_Textarea, {
          modelValue: form.note_symptom,
          "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((form.note_symptom) = $event)),
          "aria-describedby": "description-help",
          type: "text",
          size: "large",
          name: "note_symptom",
          rows: "10",
          cols: "30",
          class: "max-w-450 max-h-5rem w-full",
          placeholder: "気になる部位・お悩みの症状を入力してください"
        }, null, 8, ["modelValue"])
      ]),
      (!props.hasEdit)
        ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
            _createVNode(_component_Button, {
              class: "btn-white min-w-212 h-3rem w-11rem",
              label: "キャンセル",
              onClick: onClose
            }),
            _createVNode(_component_Button, {
              class: "btn-primary flex justify-content-end ml-3 min-w-212 h-3rem w-11rem",
              label: "新規作成",
              disabled: !_unref(get)(pass.value),
              onClick: onSave
            }, null, 8, ["disabled"])
          ]))
        : _createCommentVNode("", true)
    ], 512)
  ]))
}
}

})